import { Box, Button, Card, Stack, Typography } from '@mui/material';
import React, { ReactElement, useCallback } from 'react';
import InfoRow from '../../components/InfoRow';
import { GetCycleResponseItem } from './types';
import { getAge } from '../../utils';
import styled, { Styled } from 'styled-components';
import { fontSizes } from '../../theme';
import { useApp } from '../../contexts/AppContext';
interface PatientInfoCardProps {
    cycle: GetCycleResponseItem;
    onExpand: () => void;
}

const StyledSeeMoreButton = styled(Button)(({ theme }) => ({
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontWeight: 500,
    padding: "0!important",
    margin: "0!important",
    textDecoration: 'underline!important',
    '&:hover': {
        backgroundColor: 'transparent',
    }
}));

const PatientInfoCard: React.FC<PatientInfoCardProps> = ({ cycle, onExpand }) => {

    const patientInfoRow = useCallback((label: string, value: string | number | ReactElement, date?: Date) => (
        <InfoRow label={label} value={value} date={date} />
    ), []);

    const {translate} = useApp();
    const translations = translate('general');

    return (

        <Card>
            <Box sx={{ padding: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
                <Typography fontSize={fontSizes.lg} fontWeight="medium">
                    Patient Details
                </Typography>

                {/* Patient Information */}
                <Stack gap={1}>
                    {patientInfoRow('Name', cycle.patient)}
                    {patientInfoRow('Age', getAge(new Date(cycle.birth)))}
                    {patientInfoRow('Height', cycle.height)}
                    {patientInfoRow('Weight', cycle.weight)}
                    {patientInfoRow('AMH Level', cycle.amh)}
                    {patientInfoRow('FSH Level', cycle.fsh)}
                    {patientInfoRow('AFC', (
                        <Stack direction={"row"} gap={0} alignItems={"center"}>
                            <Typography variant='body2'>R:</Typography>
                            <Typography variant="report.info.label">{cycle.afc_right}</Typography>
                            <Typography variant='body2'>,</Typography>
                            <Typography variant='body2'>L:</Typography>
                            <Typography variant="report.info.label">{cycle.afc_left}</Typography>
                        </Stack>
                    ))}
                    {patientInfoRow('Diagnosis', cycle.diagnosis)}
                    <Box>
                        <StyledSeeMoreButton onClick={onExpand}>
                            {translations.patientInfo.seeMore}
                        </StyledSeeMoreButton>
                    </Box>
                </Stack>
            </Box>
        </Card>
    );
};

export default PatientInfoCard;
